import { createSlice } from '@reduxjs/toolkit';
import { reHydrateStore } from '../utils/local-storage';

const slice = createSlice({
  name: 'event',
  initialState: reHydrateStore('event') || null,
  reducers: {
    setEvent: (state, { payload }) => ({
      ...payload,
      is_survey: payload?.is_survey ?? false,
    }),
  },
});

export const { setEvent } = slice.actions;

export default slice.reducer;

export const selectCurrentEvent = (state) => state.event;